// extracted by mini-css-extract-plugin
export var container = "heading-module--container--CGsUE";
export var subtitleText = "heading-module--subtitle-text--4Y9zY";
export var titleText = "heading-module--title-text--vmMRA";